import {gql} from "@apollo/client";

export const GET_PAYMENT_HISTORY = gql`
          query GetPaymentHistory($after: String,$before:String, $first: Int, $last: Int,$where:PaymentTxFilterInput){
                  paymentHistory (order: {timeStamp:DESC},first: $first,last:$last, after: $after , before: $before, where:$where){
                    pageInfo {
                        endCursor
                        hasNextPage
                        hasPreviousPage
                        startCursor
                    }
                    nodes {
                      id
                      timeStamp
                      lastStatusUpdate
                      product {
                        id
                        name
                      }
                      iban
                      amount
                      creditTx {
                        id
                        type
                        timeStamp
                        amount
                        balanceAfter
                      }
                      debitTx {
                        id
                        type
                        timeStamp
                        amount
                        balanceAfter
                      }
                      status
                      type
                    }
                  }
                }
          `;

